import script from "./PaymentList.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentList.vue?vue&type=script&setup=true&lang=js"

import "./PaymentList.vue?vue&type=style&index=0&id=3d832d17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d832d17"]])

export default __exports__